module.exports = __webpack_public_path__ + "img/fb.d8c1391d.svg";